import type { LevelDetails } from "@features/dynamic-incentives/domain";

export const LEVELS: LevelDetails[] = [
  {
    level: 1,
    minOrders: 20,
    maxOrders: 249,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 5,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 7,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 10,
      },
    ],
  },
  {
    level: 2,
    minOrders: 250,
    maxOrders: 999,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 6,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 8,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 11,
      },
    ],
  },
  {
    level: 3,
    minOrders: 1000,
    maxOrders: 2499,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 7,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 9,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 12,
      },
    ],
  },
  {
    level: 4,
    minOrders: 2500,
    maxOrders: 3999,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 8,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 10,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 13,
      },
    ],
  },
  {
    level: 5,
    minOrders: 4000,
    maxOrders: 5999,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 9,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 11,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 14,
      },
    ],
  },
  {
    level: 6,
    minOrders: 6000,
    maxOrders: Infinity,
    tiers: [
      {
        minDeliveryRate: 48,
        maxDeliveryRate: 55,
        reward: 10,
      },
      {
        minDeliveryRate: 55,
        maxDeliveryRate: 65,
        reward: 12,
      },
      {
        minDeliveryRate: 65,
        maxDeliveryRate: 100,
        reward: 15,
      },
    ],
  },
];
